<template>
    <div class="theme2">
        <!-- Header -->
        <header class="theme2-header">
            <div class="theme2-header-container">
                <div class="theme2-header-content">
                    <div style="display: flex; align-items: center; gap: 1rem;">
                        <div style="display: flex; align-items: center; gap: 0.75rem; padding-right: 1rem; border-right: 1px solid #e5e7eb;">
                            <img :src="logo" alt="Padlock" class="theme2-logo">
                            <h1 style="font-size: 1.25rem; font-weight: 700; color: #111827; display: none;" :style="{ display: windowWidth >= 768 ? 'inline-block' : 'none' }">Padlock</h1>
                        </div>
                        <!-- In the template, keep this exact structure: -->
                        <div class="theme2-kid-selector">
                            <button 
                                v-for="(kid, index) in kids" 
                                :key="kid.id"
                                @click="selectKid(kid, index)"
                                style="border: none; background: none; padding: 0; cursor: pointer;"
                                :style="{ opacity: selectedKidId === kid.id ? 1 : 0.4 }"
                            >
                                <div 
                                    :class="['theme2-kid-avatar', kid.avatarBg, { 'active': selectedKidId === kid.id }]"
                                >
                                    <!-- Show profile pic OR emoji - NOT first letter -->
                                    <img 
                                        v-if="kid.profilePic" 
                                        :src="kid.profilePic" 
                                        style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;"
                                        alt="Profile"
                                    />
                                    <span v-else>{{ kid.avatar }}</span>
                                </div>
                                <span style="font-size: 0.75rem; font-weight: 500; display: block;" :style="{ color: selectedKidId === kid.id ? '#111827' : '#6b7280' }">
                                    {{ kid.name }}
                                </span>
                            </button>
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 1rem;">
                        <button @click="toggleNotifications" style="position: relative; padding: 0.5rem; background: none; border: none; cursor: pointer; border-radius: 0.5rem; transition: background 0.2s;" @mouseover="$event.currentTarget.style.background = '#f3f4f6'" @mouseleave="$event.currentTarget.style.background = 'transparent'">
                            <NotificationBellIcon />
                            <span v-if="unReadNotificationTotal > 0" style="position: absolute; top: 0.25rem; right: 0.25rem; width: 0.5rem; height: 0.5rem; background: #ef4444; border-radius: 50%;"></span>
                        </button>
                        <div style="position: relative;">
                            <button @click="toggleProfileMenu" style="background: none; border: none; cursor: pointer; padding: 0;">
                                <div style="width: 2.25rem; height: 2.25rem; background: #e5e7eb; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #6b7280; font-weight: 600; transition: background 0.2s;" :style="{ background: showProfileMenu ? '#d1d5db' : '#e5e7eb' }">P</div>
                            </button>
                            
                            <!-- Profile Dropdown Menu -->
                            <div v-if="showProfileMenu" class="theme2-modal-overlay show" @click="closeProfileMenu" style="z-index: 1100;"></div>
                            <div v-if="showProfileMenu" class="theme2-profile-dropdown">
                                <a 
                                    href="javascript:void(0)" 
                                    @click="navigateToProfile('/parent-profile')"
                                    class="theme2-profile-dropdown-item"
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink: 0;">
                                        <path d="M6.75 6C6.75 7.39239 7.30312 8.72774 8.28769 9.71231C9.27226 10.6969 10.6076 11.25 12 11.25C13.3924 11.25 14.7277 10.6969 15.7123 9.71231C16.6969 8.72774 17.25 7.39239 17.25 6C17.25 4.60761 16.6969 3.27226 15.7123 2.28769C14.7277 1.30312 13.3924 0.75 12 0.75C10.6076 0.75 9.27226 1.30312 8.28769 2.28769C7.30312 3.27226 6.75 4.60761 6.75 6Z" stroke="currentColor" stroke-width="1.5"/>
                                        <path d="M2.25 23.25C2.25 20.6641 3.27723 18.1842 5.10571 16.3557C6.93419 14.5272 9.41414 13.5 12 13.5C14.5859 13.5 17.0658 14.5272 18.8943 16.3557C20.7228 18.1842 21.75 20.6641 21.75 23.25" stroke="currentColor" stroke-width="1.5"/>
                                    </svg>
                                    <div>
                                        <div style="font-weight: 600; color: #111827;">Parent Profile</div>
                                        <div style="font-size: 0.75rem; color: #6b7280;">View your profile</div>
                                    </div>
                                </a>
                                
                                <div style="height: 1px; background: #e5e7eb; margin: 0.5rem 0;"></div>
                                
                                <a 
                                    href="javascript:void(0)" 
                                    @click="navigateToProfile('/payment-methods')"
                                    class="theme2-profile-dropdown-item"
                                >
                                    <span style="font-size: 1.25rem;">💳</span>
                                    <span>Payment Methods</span>
                                </a>
                                <a 
                                    href="javascript:void(0)" 
                                    @click="navigateToProfile('/payment-history')"
                                    class="theme2-profile-dropdown-item"
                                >
                                    <span style="font-size: 1.25rem;">📄</span>
                                    <span>Payment History</span>
                                </a>
                                <a 
                                    href="javascript:void(0)" 
                                    @click="navigateToProfile('/change-password')"
                                    class="theme2-profile-dropdown-item"
                                >
                                    <span style="font-size: 1.25rem;">🔐</span>
                                    <span>Change Password</span>
                                </a>

                                <a 
                                    href="javascript:void(0)" 
                                    @click="navigateToProfile('/contact-us')"
                                    class="theme2-profile-dropdown-item"
                                >
                                    <span style="font-size: 1.25rem;">❓</span>
                                    <span>Help</span>
                                </a>
                                
                                <div style="height: 1px; background: #e5e7eb; margin: 0.5rem 0;"></div>
                                
                                <a 
                                    href="javascript:void(0)" 
                                    @click="logout()"
                                    class="theme2-profile-dropdown-item"
                                    style="color: #dc2626;"
                                >
                                    <span style="font-size: 1.25rem;">🚪</span>
                                    <span>Logout</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <!-- Navigation (Desktop only) -->
        <nav class="theme2-nav" style="display: none;" :style="{ display: windowWidth >= 768 ? 'block' : 'none' }">
            <div class="theme2-nav-container">
                <div class="theme2-nav-tabs">
                    <button 
                        v-for="tab in filteredTabs" 
                        :key="tab.name"
                        @click="setActiveTab(tab.name)"
                        :class="['theme2-nav-tab', { 'active': activeTabFromRoute === tab.name }]"
                        style="background: none; border: none; cursor: pointer; position: relative; outline: none;"
                    >
                        <span style="text-transform: capitalize;">{{ tab.label }}</span>
                        <!-- Request Count Badge -->
                        <span 
                            v-if="tab.name === 'request' && requestCount > 0" 
                            class="theme2-nav-badge theme2-nav-badge-count"
                        >
                            {{ requestCount }}
                        </span>
                        <!-- New Badge for Location Alerts -->
                        <span 
                            v-if="tab.name === 'location-alerts'" 
                            class="theme2-nav-badge theme2-nav-badge-new"
                        >
                            New
                        </span>
                        <!-- New Badge for Schedule -->
                        <span 
                            v-if="tab.name === 'schedule' && enableSchedule" 
                            class="theme2-nav-badge theme2-nav-badge-new"
                        >
                            New
                        </span>
                    </button>
                </div>
            </div>
        </nav>

        <!-- Notifications Modal -->
        <div v-if="showNotifications" class="theme2-modal-overlay show" @click="toggleNotifications">
            <div 
                class="theme2-modal-panel show" 
                style="top: 4rem; bottom: auto; max-height: 100%; border-radius: 0.5rem;" 
                :style="{ 
                    right: windowWidth >= 768 ? '1rem' : '0',
                    left: windowWidth >= 768 ? 'auto' : '0',
                    maxWidth: windowWidth >= 768 ? '40rem' : '100%',
                    width: windowWidth >= 768 ? '40rem' : '100%',
                    margin: windowWidth >= 768 ? '0' : '0 auto',
                    borderRadius: windowWidth >= 768 ? '0.5rem' : '0'
                }"
                @click.stop
            >
                <div class="theme2-modal-header">
                    <h3 class="theme2-modal-title">Notifications</h3>
                    <button class="theme2-modal-close" @click="toggleNotifications">✕</button>
                </div>
                <div class="theme2-modal-content" style="max-height: calc(80vh - 4rem); overflow-y: auto;">
                    <div v-if="notificationList.length === 0" style="padding: 2rem; text-align: center; color: #6b7280;">
                        <p>No notifications</p>
                    </div>
                    <div v-for="notification in notificationList" :key="notification._id" style="padding: 1rem; border-bottom: 1px solid #f3f4f6;" :style="{ background: !notification.isOpen ? '#eff6ff' : 'white' }">
                        <div style="display: flex; gap: 0.75rem;">
                            <!-- In your template, update the icon display: -->
                            <div 
                                style="width: 2.5rem; height: 2.5rem; border-radius: 0.5rem; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; flex-shrink: 0; overflow: hidden;" 
                                :style="{ background: isImageIcon(notification) ? 'transparent' : getNotificationIconBg(notification) }"
                            >
                                <img 
                                    v-if="isImageIcon(notification)" 
                                    :src="getNotificationIcon(notification)" 
                                    style="width: 100%; height: 100%; object-fit: cover; border-radius: 0.5rem;"
                                    alt="Notification icon"
                                    @error="handleImageError($event, notification)"
                                />
                                <span v-else>{{ getNotificationIcon(notification) }}</span>
                            </div>
                            <div style="flex: 1; min-width: 0;">
                                <p style="font-size: 0.875rem; color: #111827; margin-bottom: 0.25rem; word-wrap: break-word; overflow-wrap: break-word;" :style="{ fontWeight: !notification.isOpen ? 600 : 500 }">
                                    {{ truncateMessage(notification.message) || 'Notification' }}
                                </p>
                                <span v-if="notification.type" style="display: inline-block; padding: 0.125rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 500; margin-top: 0.25rem;" :style="{ background: getNotificationTypeBg(notification.type), color: getNotificationTypeColor(notification.type) }">
                                    {{ notification.type }}
                                </span>
                                <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.25rem; flex-wrap: wrap;">
                                    <span style="font-size: 0.75rem; font-weight: 500; color: #111827;">{{ notification.formattedTime || formatDate(notification.created_at) }}</span>
                                    <span v-if="notification.created_at" style="font-size: 0.75rem; color: #9ca3af;">•</span>
                                    <span v-if="notification.created_at" style="font-size: 0.75rem; color: #6b7280;">{{ formatDateTime(notification.created_at) }}</span>
                                </div>
                            </div>
                            <div v-if="!notification.isOpen" style="width: 0.5rem; height: 0.5rem; background: #06b6d4; border-radius: 50%; margin-top: 0.5rem; flex-shrink: 0;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import KidsService from '@/services/KidsService.js';
import UserService from '@/services/UserService.js';
import NotificationBellIcon from '@/components/icons/NotificationBellIcon.vue';

export default {
  name: 'KidHeaderTheme2',
  components: {
    NotificationBellIcon
  },
  props: {
    profileId: String,
    serialNumber: String,
    /*profileList: {
      type: Array,
      default: () => []
    },
    currentProfileIndex: {
      type: Number,
      default: 0
    },*/
    logo: {
        type: String,
        default: "/images/lya-logo.png",
    },
  },
  data() {
    return {
      profileList: [],  // Fetch kids list here
      cacheTimeout: 120 * 60 * 1000, // 120 minutes cache
      selectedKidId: this.profileId,  // Track by ID instead of index
      selectedKid: this.currentProfileIndex,
      activeTab: 'dashboard',
      showNotifications: false,
      showProfileMenu: false,
      unReadNotificationTotal: 0,
      notificationList: [],
      currentPage: 1,
      totalNotificationsCount: 0,
      windowWidth: window.innerWidth,
      requestCount: 0,
      enableSchedule: false,
      tabs: [
        { name: 'dashboard', label: 'Dashboard' },
        { name: 'apps', label: 'Apps' },
        { name: 'request', label: 'Request' },
        { name: 'location-alerts', label: 'Location Alerts' },
        { name: 'schedule', label: 'Schedule' },
        { name: 'settings', label: 'Settings' },
        { name: 'contacts', label: 'Manage Contacts' },
        { name: 'reports', label: 'Reports' },
        { name: 'device', label: 'Device' },
        { name: 'browser-logs', label: 'Browser Logs' }
      ]
    }
  },
  computed: {
    routerName() {
      return this.$route.name;
    },
    kids() {
        return this.profileList.map((profile, index) => ({
            id: profile._id,
            name: profile.profile_name,
            avatar: this.getKidAvatar(profile),
            avatarBg: this.getKidAvatarBg(index),
            profilePic: profile.profilePic,  // Show uploaded image
            serialNumber: profile.deviceDetail?.serialNumber,
            online: profile.deviceDetail?.wifiConnected || false
        }));
    },
    filteredTabs() {
      return this.tabs.filter(tab => {
        if (tab.name === 'schedule' && !this.enableSchedule) {
          return false;
        }
        return true;
      });
    },
    activeTabFromRoute() {
      const routeMap = {
        'Kids Devices': 'dashboard',
        'Applications List': 'apps',
        'Application': 'apps',
        'requests': 'request',
        'geofence': 'location-alerts',
        'schedule': 'schedule',
        'global-settings': 'settings',
        'contacts': 'contacts',
        'reports': 'reports',
        'device-info': 'device',
        'browser-logs': 'browser-logs',
        'payment-history': 'payment-history',
        'payment-methods': 'payment-methods',
        'change-password': 'change-password'
      };
      return routeMap[this.routerName] || 'dashboard';
    }
  },
  methods: {
    async getKidsList(forceRefresh = false) {
        // Check if we have cached data
        const cachedData = localStorage.getItem('kidsListCache');
        const cacheTimestamp = localStorage.getItem('kidsListCacheTime');
        
        if (!forceRefresh && cachedData && cacheTimestamp) {
            const now = Date.now();
            const cacheAge = now - parseInt(cacheTimestamp);
            
            // Use cache if less than 5 minutes old
            if (cacheAge < this.cacheTimeout) {
                this.profileList = JSON.parse(cachedData);
                console.log('Using cached kids list');
                return;
            }
        }
        
        // Fetch fresh data
        try {
            const response = await KidsService.getKidsList();
            this.profileList = response.data.data || [];
            
            // Cache the data
            localStorage.setItem('kidsListCache', JSON.stringify(this.profileList));
            localStorage.setItem('kidsListCacheTime', Date.now().toString());
            
            console.log('Fetched fresh kids list');
        } catch (e) {
            console.error('Failed to load kids list:', e);
            
            // Fallback to cache even if expired
            if (cachedData) {
                this.profileList = JSON.parse(cachedData);
                console.log('Using expired cache as fallback');
            } else {
                this.$toast.error('Failed to load kids list');
            }
        }
    },
    
    // Call this when you know the list changed (after adding/editing kid)
    refreshKidsList() {
        this.getKidsList(true);
    },
    
    // Clear cache on logout
    clearCache() {
        localStorage.removeItem('kidsListCache');
        localStorage.removeItem('kidsListCacheTime');
    },
    getKidAvatar(profile) {
    // Return emoji avatars like before (NOT first letter)
    const avatars = ['👧', '👦', '👶', '🧒', '👨', '👩'];
    
    // You can map based on profile data if you have a field for it
    // Otherwise use index-based selection
    const index = this.profileList.indexOf(profile);
    return avatars[index % avatars.length];
},
    getKidAvatarBg(profile) {
      // Return background class based on profile
      const colors = ['bg-orange-400', 'bg-blue-400', 'bg-teal-400', 'bg-purple-400', 'bg-pink-400'];
      return profile.avatarBg || colors[this.profileList.indexOf(profile) % colors.length];
    },
    selectKid(kid, index) {
        this.selectedKidId = kid.id;
        
        // Navigate to dashboard with selected kid
        this.$router.push({
            path: '/kids-device',
            query: { 
                profileId: kid.id,
                serialNumber: kid.serialNumber
            }
        });
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      
      // Navigate to the appropriate route
      const routes = {
        'dashboard': '/kids-device',
        'apps': '/play-store',
        'request': '/requests',
        'location-alerts': '/geofence',
        'schedule': '/schedule',
        'settings': '/global-settings',
        'contacts': '/contacts',
        'reports': '/reports',
        'device': '/device-info',
        'browser-logs': '/browser-logs',
        'payment-history': '/payment-history',
        'payment-methods': '/payment-methods',
        'change-password': '/change-password'
      };
      
      if (routes[tab]) {
        const query = { profileId: this.profileId };
        
        // Add serialNumber for routes that need it
        if (tab !== 'payment-history' && tab !== 'dashboard') {
          query.serialNumber = this.serialNumber;
        }
        
        // Special case for device-info route
        if (tab === 'device') {
          query.profile_id = this.profileId;
          delete query.profileId;
        }
        
        this.$router.push({
          path: routes[tab],
          query: query
        });
      }
      
      this.$emit('tab-changed', tab);
    },
    toggleNotifications() {
      if (!this.showNotifications) {
        this.getNotifications();
      }
      this.showNotifications = !this.showNotifications;
      this.showProfileMenu = false; // Close profile menu when opening notifications
    },
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
      this.showNotifications = false; // Close notifications when opening profile menu
    },
    closeProfileMenu() {
      this.showProfileMenu = false;
    },
    navigateToProfile(route) {
      const query = { profileId: this.profileId };
      
      if (route !== 'payment-history') {
        query.serialNumber = this.serialNumber;
      }
      
      this.$router.push({
        path: route,
        query: query
      });
      
      this.closeProfileMenu();
    },
    async logout() {
      localStorage.removeItem('userTheme');
      this.clearCache();
      this.closeProfileMenu();
      
      let data = {
        serialNumber: this.serialNumber,
        profileId: this.profileId
      };
      
      try {
        const response = await UserService.logout(data);
        localStorage.removeItem('token');
        this.$toast.success(response.data.respones_msg);
        
        if (localStorage.getItem('hideGoogleLogin') === 'true') {
          window.location.href = '/login?hideGBtn=true';
        } else {
          this.$router.push('/login');
        }
      } catch (e) {
        this.$toast.error(e.response?.data?.respones_msg || 'Logout failed');
      }
    },
    async getNotifications() {
      let data = {
        serialNumber: this.serialNumber,
        currentPage: this.currentPage
      }
      await KidsService.getNotifications(data)
      .then((response) => {
        this.notificationList = response.data.data;
        this.totalNotificationsCount = response.data.totalNotifications;
        this.unReadNotificationTotal = 0;
      }).catch((e) => {
        this.$toast.error(e.response.data.respones_msg);
      });
    },
    async unReadNotificationCount() {
      let data = {
        serialNumber: this.serialNumber,
        profileId: this.profileId
      }
      await KidsService.unReadNotificationCount(data)
      .then((response) => {
        this.unReadNotificationTotal = response.data.data;
        this.requestCount = response.data.appRequestCount;
        this.enableSchedule = response.data.enableSchedule;
      }).catch((e) => {
        this.$toast.error(e.response.data.respones_msg);
        if (e.response.data.is_logout == true) {
          this.$router.push({ path: '/login'});
        }
      });
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    // In your methods section, update:

    getNotificationIcon(notification) {
        // Return icon (could be emoji or image URL)
        if (notification.icon) return notification.icon;
        if (notification.type) {
            const typeIcons = {
                'error': '⚠️',
                'success': '✅',
                'warning': '⚠️',
                'info': 'ℹ️',
                'policy': '🛡️',
                'app': '📱',
                'device': '📲'
            };
            return typeIcons[notification.type.toLowerCase()] || '🔔';
        }
        return '🔔';
    },
    
    isImageIcon(notification) {
        // Check if icon is an image URL
        const icon = this.getNotificationIcon(notification);
        if (!icon) return false;
        
        // Check if it's a URL (starts with http, https, or /)
        return icon.startsWith('http://') || 
               icon.startsWith('https://') || 
               icon.startsWith('/') ||
               icon.startsWith('data:image') ||
               icon.includes('.jpg') ||
               icon.includes('.jpeg') ||
               icon.includes('.png') ||
               icon.includes('.gif') ||
               icon.includes('.svg') ||
               icon.includes('.webp');
    },
    
    handleImageError(event, notification) {
        // Fallback to emoji if image fails to load
        console.error('Failed to load notification icon:', notification.icon);
        event.target.style.display = 'none';
        event.target.parentElement.innerHTML = '🔔';
        event.target.parentElement.style.background = '#f3f4f6';
    },
    
    getNotificationIconBg(notification) {
        // Return background color based on notification type
        if (notification.type) {
            const typeBg = {
                'error': '#fee2e2',
                'success': '#d1fae5',
                'warning': '#fef3c7',
                'info': '#dbeafe',
                'policy': '#e0e7ff',
                'app': '#f3e8ff',
                'device': '#fce7f3'
            };
            return typeBg[notification.type.toLowerCase()] || '#f3f4f6';
        }
        return '#f3f4f6';
    },
    getNotificationTypeBg(type) {
      const bgColors = {
        'error': '#fee2e2',
        'success': '#dcfce7',
        'warning': '#fed7aa',
        'info': '#dbeafe',
        'policy': '#e0e7ff',
        'app': '#f3e8ff'
      };
      return bgColors[type?.toLowerCase()] || '#f3f4f6';
    },
    getNotificationTypeColor(type) {
      const textColors = {
        'error': '#dc2626',
        'success': '#166534',
        'warning': '#9a3412',
        'info': '#1e40af',
        'policy': '#4338ca',
        'app': '#7c3aed'
      };
      return textColors[type?.toLowerCase()] || '#374151';
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const now = new Date();
      const diffInMs = now - date;
      const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
      const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
      
      if (diffInHours < 1) {
        const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
        return `${diffInMinutes} min ago`;
      } else if (diffInHours < 24) {
        return `${diffInHours} hours ago`;
      } else if (diffInDays === 1) {
        return '1 day ago';
      } else if (diffInDays < 7) {
        return `${diffInDays} days ago`;
      } else {
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      }
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('en-US', { 
        month: 'short', 
        day: 'numeric', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    },
    truncateMessage(message, maxLength = 200) {
      if (!message) return '';
      if (message.length <= maxLength) return message;
      return message.substring(0, maxLength) + '...';
    }
  },
  watch: {
    serialNumber() {
      this.unReadNotificationCount();
    },
    profileId() {
        this.selectedKidId = this.profileId;
        this.unReadNotificationCount();
    }
  },
  mounted() {
    this.getKidsList();  // Fetch kids on mount
    this.unReadNotificationCount();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
/* Remove focus outline from all buttons */
button:focus,
button:active,
button:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

/* Kid selector buttons */
.theme2-kid-selector button:focus,
.theme2-kid-selector button:active {
  outline: none !important;
}

/* Navigation tab buttons */
.theme2-nav-tab:focus,
.theme2-nav-tab:active {
  outline: none !important;
}

/* Navigation Badges */
.theme2-nav-badge {
  position: absolute;
  top: 0.25rem;
  right: -0.75rem;
  font-size: 0.625rem;
  font-weight: 700;
  padding: 0.125rem 0.375rem;
  border-radius: 0.75rem;
  line-height: 1.2;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: badge-pulse 2s ease-in-out infinite;
}

.theme2-nav-badge-count {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  min-width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 0;
  font-size: 0.65rem;
}

.theme2-nav-badge-new {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  font-size: 0.6rem;
  padding: 0.15rem 0.4rem;
}

@keyframes badge-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* Profile Dropdown */
.theme2-profile-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  min-width: 16rem;
  z-index: 1101;
  border: 1px solid #e5e7eb;
  padding: 0.5rem;
}

.theme2-profile-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  text-decoration: none;
  color: #111827;
  border-radius: 0.375rem;
  transition: background 0.2s;
  font-size: 0.875rem;
  cursor: pointer;
}

.theme2-profile-dropdown-item:hover {
  background: #f3f4f6;
  color: #111827;
}

.theme2-profile-dropdown-item:active {
  background: #e5e7eb;
}
</style>